const DocumentsTab = ({ company }) => {

  return (
    <div className="lg:col-span-2 bg-slate-900/80 border text-sm border-white/10 rounded-lg p-4">
      <p p className="text-slate-400">Coming Soon!</p>
    </div>
  );
};

export default DocumentsTab;
